
export function getProductJson(handle) {
  let root = window.theme.routes.root_url || '';
  if (root[root.length - 1] !== '/') {
    root = `${root}/`;
  }
  const requestRoute = `${root}products/${handle}.js` || '/recommendations/products/';
  return window.fetch(requestRoute).then((response) => {
    return response.json();
  }).catch((e) => {
    console.error(e);
  });
}
